import { render } from "./DataInventoryAnalysisTabs.vue?vue&type=template&id=2a059697"
import script from "./DataInventoryAnalysisTabs.vue?vue&type=script&lang=js"
export * from "./DataInventoryAnalysisTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__